import { calculate } from './calculate.js';

export function createState(root) {
  const dataNode = root.querySelector('[data-converter-initial]');
  const initial = JSON.parse(dataNode?.textContent || '{}');
  const state = {
    root,
    mode: initial.mode === 'buy' ? 'buy' : 'convert',
    rememberPreferences: initial.mode !== 'buy' && initial.rememberPreferences === true
      && window.location.pathname === '/convert/',
    userInteracted: false,
    base: initial.base,
    quote: initial.quote,
    baseAmount: Number(initial.baseAmount) || 0,
    quoteAmount: Number(initial.quoteAmount) || 0,
    lastEdited: initial.mode === 'buy' ? 'quote' : 'base',
    selectedSide: 'base',
    activeTab: 'all',
    searchTimer: 0,
    amountUrlTimer: 0,
    searchController: null,
    searchRequestId: 0,
    pairController: null,
    pairRequestId: 0,
    searchCache: new Map(),
    defaultCache: new Map(),
    pairCache: new Map(),
    dialog: null,
    restoreFocus: null,
    pairUrl: window.location.pathname + window.location.search,
  };
  return calculate(state, state.lastEdited);
}
